import { useTranslate } from '@repo/shared/hooks'
import { Card, CenterBox, Col, Icon, Typography } from '@repo/ui/components'
import type { IKycSuccessProps } from './kyc.types'
import { ButtonLink } from '@repo/shared/components'

export const KycSuccess = (props: IKycSuccessProps) => {
  const { mobileOrEmail } = props
  const { t } = useTranslate()

  return (
    <Card className='p-xl rounded-sm'>
      <Col className='gap-md items-center'>
        <CenterBox className='bg-positive-surface-100/20 rounded-full'>
          <Icon
            name='CheckCircleGhost'
            className='size-full rounded-full'
            size='2xl'
            color='fill-positive-surface-100'
          />
        </CenterBox>

        <Typography
          size='lg'
          weight='bold'
          color='text-positive-surface-100'
          className='text-center'
        >
          {t('kyc_success_title', {
            mobileOrEmail,
          })}
        </Typography>
        <Typography
          size='md'
          color='text-alert-surface-100'
          className='text-center'
        >
          {t('kyc_success_description')}
        </Typography>
        <ButtonLink variant='ghost' width='full' size='lg' href='/'>
          {t('common_go_to_home_page')}
        </ButtonLink>
      </Col>
    </Card>
  )
}
